import { useSelector } from 'react-redux';
import { selectAppHasSelectCapabilitiesConfigured } from '../../selectors/selectors';
import { IntegrationCapability } from '../../types';
import { RootState } from '../../reducers/reducers';

const useHasIntegrationCapabilityInstalled: (appId: string, integrationCapability: IntegrationCapability) => boolean = (
    appId,
    integrationCapability,
) => {
    const hasCapabilityInstalled = useSelector((state: RootState) =>
        selectAppHasSelectCapabilitiesConfigured(state, appId, [integrationCapability]),
    );

    return hasCapabilityInstalled;
};

export default useHasIntegrationCapabilityInstalled;
